<template>
<div class="chapter">
<div class="inner_page">
<div><img alt="image" height="100%" src="Images/frn_fig_003.png" width="100%"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TitlePage.vue?3c40fbd6